import styled from 'styled-components';

export const CleanUnorderedList = styled.ul`
  padding-left: 0;
  list-style-type: none;
  margin-top: 0;
`;

export const ListItem = styled.li`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;
